import { Filter } from '@app/utils/_msf';
import { FilterOperator } from '@app/utils/filter-operator';

export const visibleTagFilter: Filter = {
  filterField: 'visible',
  filterOperator: FilterOperator.Equals,
  filterValue: true,
};

export function withVisibleTagFilter(filters: Filter[] = []): Filter[] {
  return [...(filters || []), visibleTagFilter];
}
